import {getToken,setToken,removeToken} from '@/utils/auth.js'
import {login, logout, getInfo} from '@/api/user.js'
const state = {
	token: getToken(),
	name:'',
	// 性别
	gender:'',
	// 头像
	avatar:'',
	// 手机号
	phone:'',
	// 身份证号
	idCard:'',
	// id
	userId:'',
	// 课程Id
	courseId:'',
	// 全部
	profile: {},
	
}
const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	// 姓名
	SET_NAME: (state, name) => {
		state.name = name
	},
	// 头像
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	// 性别
	SET_GENDER: (state,gender) =>{
		state.gender = gender	
	},
	// 电话
	SET_PHONE: (state,phone) => {
		state.phone = phone	
	},
	// 学号
	SET_IDCARD: (state,idCard) => {
		state.idCard = idCard	
	},
	// 个人信息详情
	SET_PROFILE:(state,profile) => {
		state.profile = profile
	},
	// 个人Id
	SET_USERID:(state,userId) => {
		state.userId = userId
	},
	SET_COURSEID:(state,courseId)=>{
		state.courseId = courseId
	}
}
const actions = {
	// user login
	login({ dispatch, commit }, userInfo) {
		
		const { username, password } = userInfo
		return new Promise((resolve, reject) => {
			console.log(login)
		  login({ username: username.trim(), password: password }).then(response => {
			const { token } = response
			commit('SET_TOKEN', token)
			setToken(token)
			resolve()
		  }).catch(error => {
			reject(error)
		  })
		})
	},

	// get user info
	getInfo({ commit, state }) {
		return new Promise((resolve, reject) => {
		  getInfo().then(response => {
			  // console.log(response)
			const { data } = response
			if (!data) {
			  reject('Verification failed, please Login again.')
			}
			const { name, idCard,gender,phone,id,currentCourseId,avatar } = data
			commit('SET_NAME', name)
			commit('SET_GENDER', gender)
			commit('SET_PHONE', phone)
			commit('SET_IDCARD', idCard)
			commit('SET_AVATAR', avatar)
			commit('SET_PROFILE',data)
			commit('SET_USERID',id)
			commit('SET_COURSEID',currentCourseId)
			resolve(data)
		  }).catch(error => {
			console.log('user',error)
			reject('Verification failed, please Login again.')
			// 个人信息获取失败返回登录页
			// uni.redirectTo({
			//     url: '/pages/login/index'
			// });
			reject(error)
		  })
		})
	},

	// user logout
	logout({ commit, state }) {
		return new Promise((resolve, reject) => {
		  logout(state.token).then(() => {
			  // 姓名
			commit('SET_NAME', '')
			// 性别
			commit('SET_GENDER', '')
			// 电话
			commit('SET_PHONE', '')
			// 学号
			commit('SET_IDCARD', '')
			// 头像
			commit('SET_AVATAR', '')
			// 详细信息
			commit('SET_PROFILE',{})
			// 清空token
			commit('SET_TOKEN',undefined)
			// 清空个人Id
			commit('SET_USERID','')
			// 删除本地token
			removeToken()
			resolve()
		  }).catch(error => {
			reject(error)
		  })
		})
	},
	reset({ commit, state }){
		return new Promise((resolve,resject) => {
			// 姓名
			commit('SET_NAME', '')
			// 性别
			commit('SET_GENDER', '')
			// 电话
			commit('SET_PHONE', '')
			// 学号
			commit('SET_IDCARD', '')
			// 头像
			commit('SET_AVATAR', '')
			// 详细信息
			commit('SET_PROFILE',{})
			// 清空token
			commit('SET_TOKEN',undefined)
			// 清空个人Id
			commit('SET_USERID','')
			// 删除本地token
			removeToken()
			resolve()
		})
	}
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
